import { z } from 'zod'
import type { ContactTranslations } from '../i18n/translations.types'
import { defaultTranslations } from '../i18n/defaultTranslations'

export function createContactPhoneSchema(t: ContactTranslations['schema']) {
  return z.object({
    category: z.number(),
    countryId: z.string().min(1, t.phone.countryRequired),
    areaCode: z.string().max(3, t.phone.areaCodeMaxLength),
    number: z.string().trim().min(1, t.phone.numberRequired).max(10, t.phone.numberMaxLength),
    extension: z.string().max(3, t.phone.extensionMaxLength),
  })
}

export function createContactSocialNetworkSchema(t: ContactTranslations['schema']) {
  return z.object({
    socialNetworkTypeId: z.string().min(1, t.socialNetwork.typeRequired),
    url: z.string().trim().min(1, t.socialNetwork.urlRequired).max(2048, t.socialNetwork.urlMaxLength),
  })
}

export function createContactSchema(t: ContactTranslations['schema'], options?: { requireClassification?: boolean }) {
  const emailItemSchema = z
    .string()
    .email(t.email.invalidFormat)
    .max(256, t.email.maxLength)

  const useForSchema = options?.requireClassification
    ? z.array(z.number()).min(1, t.useFor.required)
    : z.array(z.number())

  return z.object({
    name: z.string().trim().min(1, t.name.required).max(200, t.name.maxLength),
    emails: z.array(emailItemSchema),
    address: z.string().max(500, t.address.maxLength).nullable(),
    description: z.string().nullable(),
    cityId: z.string().nullable().optional(),
    neighborhoodId: z.string().nullable().optional(),
    useFor: useForSchema,
    phones: z.array(createContactPhoneSchema(t)),
    socialNetworks: z.array(createContactSocialNetworkSchema(t)),
  })
}

// Backward-compatible module-level exports (default Spanish)
const _defaultSchema = defaultTranslations.schema
export const contactPhoneSchema = createContactPhoneSchema(_defaultSchema)
export const contactSocialNetworkSchema = createContactSocialNetworkSchema(_defaultSchema)
export const contactSchema = createContactSchema(_defaultSchema)
export type ContactFormData = z.infer<typeof contactSchema>
